'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

LinePlotterDirective=function(_BaseControllerBacked){_inherits(LinePlotterDirective,_BaseControllerBacked);function LinePlotterDirective(){_classCallCheck(this,LinePlotterDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(LinePlotterDirective,[{key:'objectBindings',get:function()
{
return['points','verticalAxis','horizontalAxis','plotArea'];
}},{key:'textBindings',get:function()
{
return['propNameForX','propNameForY','interpolation','class'];
}},{key:'controller',get:function()

{
return LinePlotterController;
}}]);return LinePlotterDirective}(BaseControllerBackedDirective);let


LinePlotterController=function(){_createClass(LinePlotterController,null,[{key:'$inject',get:function()
{
return['$scope'];
}}]);

function LinePlotterController($scope){var _this2=this;_classCallCheck(this,LinePlotterController);
$scope.$watch('controller.plotArea',function(){
if(_.exists(_this2.plotArea)){
_this2.plotArea.registerPlotter(_this2);
}
});
}LinePlotterController.prototype.









redraw=function redraw(){var _this3=this;
if(!this._scalesValid){
return;
}

let line=d3.svg.line().
x(function(point){return _this3.horizontalAxis.scale(point[_this3.propNameForX])}).
y(function(point){return _this3.verticalAxis.scale(point[_this3.propNameForY])}).
interpolate(this.interpolation);

d3.select(this.plotArea.svgElement).
append('g').
attr('class',`${this.class}`).
append('path').
attr('fill','none').
attr('d',line(this.points));
};_createClass(LinePlotterController,[{key:'_scalesValid',get:function(){return _.exists(this.horizontalAxis)&&_.exists(this.horizontalAxis.scale)&&_.exists(this.verticalAxis)&&_.exists(this.verticalAxis.scale)}}]);return LinePlotterController}();


module.exports=LinePlotterDirective;
//# sourceMappingURL=linePlotterDirective.js.map
